import React, { Fragment, useEffect, useState } from 'react'
import { BreadcrumbItem } from './BreadcrumbItem'
import type { RequiredProductBreadcrumbsProps } from './Breadcrumbs'

export const BreadcrumbsPDP = (
    props: RequiredProductBreadcrumbsProps
): JSX.Element | null => {
    const { product, rootText, urlSuffix, urlPrefix } = props

    const [originCategoryPath, setOriginCategoryPath] = useState<string | null>(
        null
    )
    // Query (filtros + orden) activa en la categoría de origen: el enlace del
    // breadcrumb a esa categoría la conserva para no perder el estado al volver.
    const [originCategorySearch, setOriginCategorySearch] = useState('')

    useEffect(() => {
        const stored = sessionStorage?.getItem('origin-category-path')
        setOriginCategoryPath(stored)
        const storedSearch = sessionStorage?.getItem('origin-category-search')
        setOriginCategorySearch(
            storedSearch && storedSearch.startsWith('?') ? storedSearch : ''
        )
    }, [])

    // 👇 hasta que tengamos el valor, no renderizamos nada
    if (originCategoryPath === null) {
        return null
    }

    const { breadcrumbsData } = product.categories.reduce(
        (acc, category) => {
            if (acc.blockAccumulation) return acc

            const { url_path } = category
            if (!url_path) return acc

            const subCategories = url_path.split('/')

            if (originCategoryPath.includes(url_path)) {
                if (url_path == 'espacio-de-la-casa') {
                    acc.maxLength = 0
                    acc.breadcrumbsData = []
                }
                acc.maxLength = subCategories.length
                acc.breadcrumbsData.push(category)
                if (originCategoryPath == url_path) {
                    acc.blockAccumulation = true
                }
            }

            return acc
        },
        { maxLength: 0, breadcrumbsData: [], blockAccumulation: false } as {
            maxLength: number
            breadcrumbsData: {
                name: string
                url_path: string
            }[]
            blockAccumulation: boolean
        }
    )

    return (
        <span>
            <BreadcrumbItem url="/" title={rootText} />
            {breadcrumbsData.map((breadcrumb) => {
                const { name = '', url_path } = breadcrumb
                return (
                    <Fragment key={url_path}>
                        {props.separator}
                        <BreadcrumbItem
                            url={`${urlPrefix}/${url_path}${urlSuffix}${
                                url_path === originCategoryPath
                                    ? originCategorySearch
                                    : ''
                            }`}
                            title={name}
                            key={url_path}
                        />
                    </Fragment>
                )
            })}
        </span>
    )
}
